import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="px-4 md:px-6 py-10 md:py-14">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                  <i className="ri-file-list-3-line text-xl"></i>
                </div>
                <h3 className="font-heading font-bold text-foreground-950 text-lg">Yoybuy Sheet</h3>
              </div>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Таблицы для шоппинга через Yoybuy. Найдите лучшие товары из Китая с проверенными ссылками.
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-950 text-sm mb-4">Навигация</h4>
              <div className="flex flex-col gap-2">
                <Link to="/" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Главная
                </Link>
                <Link to="/yoybuy-spreadsheet-guide" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer">
                  Руководство
                </Link>
                <a
                  href="https://kaspreadsheet.com"
                  target="_blank"
                  rel="noopener nofollow"
                  className="text-foreground-600 hover:text-primary-600 transition-colors text-sm whitespace-nowrap cursor-pointer"
                >
                  kaspreadsheet.com
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-950 text-sm mb-4">Популярные статьи</h4>
              <div className="flex flex-col gap-2">
                <Link to="/yoybuy-dlya-nachinayushih" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Для начинающих
                </Link>
                <Link to="/yoybuy-kakobuy-sravnenie" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Yoybuy vs Kakobuy
                </Link>
                <Link to="/luchshie-nahodki-yoybuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Лучшие находки
                </Link>
                <Link to="/dostavka-yoybuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Доставка
                </Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-foreground-950 text-sm mb-4">Сравнения</h4>
              <div className="flex flex-col gap-2">
                <Link to="/yoybuy-vs-superbuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Yoybuy vs Superbuy
                </Link>
                <Link to="/bezopasnost-yoybuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Безопасность
                </Link>
                <Link to="/qc-gid-yoybuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  QC гид
                </Link>
                <Link to="/kupony-yoybuy" className="text-foreground-600 hover:text-primary-600 transition-colors text-sm cursor-pointer">
                  Купоны
                </Link>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70 text-center">
            <p className="text-foreground-500 text-xs">
              © 2026 Yoybuy Sheet. Все права защищены.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}